import React, { Fragment } from 'react'
import { Box, IconButton } from '@material-ui/core'
import { X as XIcon } from 'react-feather'

import { NewChatConfirmDialog } from './components'
import { ChatPlusIcon } from 'components/CustomIcons'

import useDaiChat from 'hooks/useDaiChat'

import useStyles from './styles'

const ChatHeaderActions = ({ chatSize }) => {
  const classes = useStyles()
  const {
    hasMessage,
    handleNewChat,
    handleCloseChat,
    newChatDialogOpen,
    confirmNewChat,
    cancelNewChat,
  } = useDaiChat()

  const fixed = chatSize === 'fixed'

  return (
    <Box display="flex" alignItems="center">
      {hasMessage && (
        <Fragment>
          <IconButton
            onClick={() => handleNewChat()}
            className={classes.chatActionButton}
          >
            <ChatPlusIcon size={18} className={classes.chatActionIcon} />
          </IconButton>
        </Fragment>
      )}

      {!fixed && (
        <Fragment>
          <IconButton
            onClick={handleCloseChat}
            className={classes.chatActionButton}
          >
            <XIcon size={22} className={classes.chatActionIcon} />
          </IconButton>
        </Fragment>
      )}

      <NewChatConfirmDialog
        open={newChatDialogOpen}
        setOpen={cancelNewChat}
        onConfirm={confirmNewChat}
      />
    </Box>
  )
}

export default ChatHeaderActions
